import React from "react";
import config from "../../../config/config";
export function QuoteProfile(props) {
  const {
    vendorName,
    aboutUs,
    successfulMoves,
    happyClients,
    yearsOfService,
    address,
    logo,
    vendorId,
    vendorUrlName,
  } = props;
  const JSX = (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <div className="vendor-details-container d-flex flex-row align-items-center mb-3">
            <div className="mr-2 vendor-logo">
              <img
                src={`${config.vendorImagesPath}${vendorId}/${logo}`}
                alt="logo"
                width="50"
                height="50"
                className="img-fluid"
              />
            </div>
            <div className="vendor-details">
              <div className="label">{vendorName}</div>
              <div className="vendor-address">
                <img
                  src={`${config.customerPortal}includes/img/customerDashboard/pin.png`}
                  alt="map"
                  width="10"
                  height="10"
                  className="img-fluid"
                />{" "}
                {address}
              </div>
            </div>
          </div>
          <div className="vendor-stats">
            <div className="row stats-container">
              <div className="col-sm-4 list-content">
                <div className="vendor-stats-data">{yearsOfService}</div>
                <div className="vendor-stats-info">Years Of Service</div>
              </div>
              <div className="col-sm-4 list-content">
                <div className="vendor-stats-data">{successfulMoves}</div>
                <div className="vendor-stats-info">Successful Moves</div>
              </div>
              <div className="col-sm-4 list-content">
                <div className="vendor-stats-data">{happyClients}</div>
                <div className="vendor-stats-info">Happy Clients</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 mb-1">
          <div className="label mb-2">About {vendorName}</div>
          <p className="info">
            {aboutUs}
            {vendorUrlName !== null && (
              <span
                onClick={() => {
                  window.open(
                    `${config.customerPortal}packers-and-movers-vendor/${vendorUrlName}`,
                    "_blank"
                  );
                }}
                className="text-active"
              >
                Full Profile
              </span>
            )}
          </p>
        </div>
      </div>
    </>
  );
  return JSX;
}
